import { useRef } from 'react';
import { updateWishlist } from '../api/Wishlist';
import { useWishlistContext } from '../providers/WishlistProvider';
import { toast } from 'react-toastify';

export const useWishlist = () => {
    const { toggleWishlistId, isInWishlist } = useWishlistContext();
    const pendingRef = useRef<Set<number | string>>(new Set());

    /**
     * Toggle wishlist — optimistic update qua WishlistProvider.
     * Context cập nhật ngay, API chạy ngầm. Revert nếu fail.
     */
    const handleToggleWishlist = (productId: number | string) => {
        if (pendingRef.current.has(productId)) return;
        pendingRef.current.add(productId);

        // Xác định trạng thái trước khi toggle để hiển thị thông báo đúng
        const wasInWishlist = isInWishlist(Number(productId));

        // Optimistic: toggle trong context ngay lập tức
        toggleWishlistId(Number(productId));

        // Thông báo optimistic
        toast.success(wasInWishlist ? 'Đã xóa khỏi sản phẩm quan tâm' : 'Đã thêm vào sản phẩm quan tâm', {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: true,
        });

        // API chạy ngầm
        updateWishlist(productId).then((res) => {
            pendingRef.current.delete(productId);

            if (!res || !res.status) {
                // API thất bại → revert
                toggleWishlistId(Number(productId));
                toast.error('Cập nhật thất bại, đã hoàn tác.', {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                });
            }
        }).catch(() => {
            pendingRef.current.delete(productId);
            toggleWishlistId(Number(productId));
            toast.error('Cập nhật thất bại, đã hoàn tác.', {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: true,
            });
        });
    };

    return {
        handleToggleWishlist,
        isInWishlist,
    };
};